/**
 * Secure buffer zeroization utility
 */

/**
 * Securely overwrites the contents of a buffer with zeros.
 * This helps prevent sensitive data from remaining in memory after use.
 *
 * @param buf - Buffer to zeroize (Uint8Array, ArrayBuffer, or DataView)
 */
export function zeroize(buf) {
  // NOOP on undefined
  if (buf === undefined) {
    return;
  }

  // Handle different buffer types
  if (buf instanceof Uint8Array) {
    buf.fill(0);
  } else if (buf instanceof ArrayBuffer) {
    new Uint8Array(buf).fill(0);
  } else if (buf instanceof DataView) {
    const bytes = new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    bytes.fill(0);
  }
}